import { render } from "./HeartBenefits.vue?vue&type=template&id=79d57fa3"
import script from "./HeartBenefits.vue?vue&type=script&lang=js"
export * from "./HeartBenefits.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__